/**
 * @typedef {Object} BookingClassificationViewModelType
 * @property {number} id - Unique identifier
 * @property {string} onlineTitle - The online friendly name for the classification
 */

/**
 * @class
 */
export default class BookingClassificationViewModel {
  /**
   * Create a new BookingClassificationViewModel.
   * @param {...BookingClassificationViewModelType} params
   */
  constructor(params) {
    this.id = params.id
    this.onlineTitle = params.onlineTitle
  }
}
